module.exports = __webpack_public_path__ + "static/media/ope1.png.e3726205.jpg";